__turbopack_context__.v({
  "container": "VisaTypes-module__xqVF0a__container",
  "contentBox": "VisaTypes-module__xqVF0a__contentBox",
  "description": "VisaTypes-module__xqVF0a__description",
  "feesBlock": "VisaTypes-module__xqVF0a__feesBlock",
  "feesIntro": "VisaTypes-module__xqVF0a__feesIntro",
  "feesTable": "VisaTypes-module__xqVF0a__feesTable",
  "feesTitle": "VisaTypes-module__xqVF0a__feesTitle",
  "section": "VisaTypes-module__xqVF0a__section",
  "tableNote": "VisaTypes-module__xqVF0a__tableNote",
  "tableWrapper": "VisaTypes-module__xqVF0a__tableWrapper",
  "title": "VisaTypes-module__xqVF0a__title",
});
